import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { ActionButton, BaseButton, Breadcrumb, Button, Checkbox, DatePicker, DayOfWeek, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, Dropdown, IBreadcrumbItem, Icon, IconButton, IDatePickerStrings, IDropdownOption, IPersonaSharedProps, Label, Panel, PanelType, PrimaryButton, Shimmer, Slider, Text, TextField, Toggle, TooltipHost } from 'office-ui-fabric-react';
import { BiInfoCircle } from "react-icons/bi";



const getPersona = () => {

  const examplePersona: IPersonaSharedProps = {
    imageUrl: '/photos/person.png',
    imageInitials: 'AL',
    text: 'Annie Lindqvist',
    secondaryText: 'Software Engineer',
    tertiaryText: 'In a meeting',
    optionalText: 'Available at 4:00pm',
  };

  return examplePersona;
};



const getSolutionArchitect = (salesProcess: any) => {
  const solutionArchitectRole = salesProcess?.fields?.roles?.find((role: any) => role.id === 'SOLUTION_ARCHITECT');

  if (solutionArchitectRole && solutionArchitectRole.user) {
    return solutionArchitectRole.user.name;
  } else {
    return '';
  }
};



const getSolutionApproval = (salesProcess: any, approvalId: string) => {
  const solutionApproval = salesProcess?.fields?.approvals?.find((approval: any) => approval.id === approvalId);

  if (solutionApproval) {
    return solutionApproval;
  } else {
    return '';
  }
};



const getComplexity = (salesProcess: any) => {
  if (salesProcess?.fields?.complexity) {
    return salesProcess.fields.complexity;
  } else {
    return 1;
  }
};



const getSolutionApprovalButton = (props: any, approvalId: string, approvalName: string) => {

  const menuProps = {
    items: [
      {
        key: 'cancel',
        text: 'Cancel',
        // iconProps: { iconName: 'Presentation' },
        onClick: () => {
          const salesProcess = { ...props.salesProcess };

          if (salesProcess.fields.approvals) {
            
            salesProcess.fields.approvals = salesProcess.fields.approvals.filter((approval: any) => approval.id !== approvalId);

            props.setSalesProcess(salesProcess);

            props.createOrSave(props.currentStep);
          }
        }
      }
    ]
  };

  const isApproved = getSolutionApproval(props.salesProcess, approvalId);

  return (
    <PrimaryButton
      text={ isApproved ? 'Approved' : 'Approve' }
      iconProps={ isApproved ? { iconName: 'SkypeCircleCheck' } : undefined }
      menuProps={ isApproved ? menuProps : undefined }
      onClick={() => {
        if (isApproved) {
        } else {
          const salesProcess = { ...props.salesProcess };

          if (!salesProcess.fields.approvals) {
            salesProcess.fields['approvals'] = [];
          }

          salesProcess.fields.approvals.push({ id: approvalId, name: approvalName });

          props.setSalesProcess(salesProcess);

          props.createOrSave(props.currentStep);
        }
      }}
    />
  );
};



const steps = [
  { name: 'Draft',       description: 'Provide the Solution details, define scope and size.' },
  { name: 'Submit',      description: 'The Regional Avanade Solution Area owner is reviewing the Solution and will assign a Solution Architect.' },
  { name: 'Collaborate', description: 'The Solution Architect will work with you to understand the solution and clarify any requirements.' },
  { name: 'Define',      description: 'The Solution Architect is defining the Avanade solution which will then pass through Avanade approvals.' },
  { name: 'Approve',     description: 'The Solution is being reviewed by Avanade stakeholders.' },
  { name: 'Close',       description: 'The Solution has been accepted and approved by Avanade. The Solution materials such as staffing, and estimates are available.' },
  { name: 'Deliver',     description: 'The opportunity has been won and Avanade is mobilizing to deliver.' }
];



const getMaxStep = (salesProcess: any) => {
  const maxStep = salesProcess.state.steps ? Math.max(...salesProcess.state.steps) : 0;
  return maxStep;
};



const getCurrentStep = (salesProcess: any) => {

  const maxStep = getMaxStep(salesProcess);

  if (maxStep > 3) {

    if (salesProcess.fields.roles) {

      const solutionArchitectRole = salesProcess.fields.roles.find((role: any) => role.id === 'SOLUTION_ARCHITECT');

      if (solutionArchitectRole && solutionArchitectRole.user) {

        if (maxStep > 5) {

          if (salesProcess.fields.approvals && Array.isArray(salesProcess.fields.approvals) && salesProcess.fields.approvals.length > 0) {
            return 6;

          } else {
            return 5;
          }

        } else {
          return 4;
        }

      } else {
        return 3;
      }

    } else {
      return 3;
    }

  } else {

    if (salesProcess.state.step === 3) {
      return 2;

    } else {
      return 1;
    }
  }
};



type WsSalesTimelineProps = {
  salesProcess: any;
};

const WsSolutionSteps = (props: WsSalesTimelineProps) => {

  const list = steps.map((step, index: number) => {

    const stepNumber = index + 1;

    const classList = [ 'ws-sales-solution-step' ];

    const currentStep = getCurrentStep(props.salesProcess);

    let stepProgress = 'pending';

    if (stepNumber === currentStep) {
      classList.push('ws-sales-solution-step-current');
      stepProgress = 'current';

    } else if (stepNumber < currentStep) {
      classList.push('ws-sales-solution-step-completed');
      stepProgress = 'completed';

    } else {
      classList.push('ws-sales-solution-step-pending');
    }

    return (
      <div className={classList.join(' ')} key={`ws-sales-solution-step-${stepNumber}`}>
        <div className="ws-sales-solution-step-circle">
          {
            stepProgress === 'completed'
            &&
            <Icon className="ws-sales-solution-step-circle-icon" iconName='SkypeCheck' />
          }
          {
            stepProgress === 'current'
            &&
            <Icon className="ws-sales-solution-step-circle-icon" iconName='CircleFill' />
          }
        </div>
        <div className="ws-sales-solution-step-number">STEP {stepNumber}</div>
        <div className="ws-sales-solution-step-name">
          <TooltipHost
            content={step.description}
            id={`ws-sales-solution-step-tooltip-${index}`}
            directionalHint={DirectionalHint.bottomCenter}
            calloutProps={{
              className: 'ws-sales-solution-step-tooltip-callout',
              style: {
                width: '200px'
              }
            }}
          >
            {step.name}

            <BiInfoCircle
              aria-describedby={`ws-sales-solution-step-tooltip-${index}`}
              style={{
                verticalAlign: 'middle',
                marginLeft: '5px',
                marginTop: '-3px'
              }}
            />
          </TooltipHost>
        </div>
      </div>
    );
  });

  return (
    <div className="ws-sales-solution-steps">
      <div className="ws-sales-solution-steps-line"></div>
      {list}
    </div>
  );
};




export {
  WsSolutionSteps,
  getMaxStep,
  getCurrentStep,
  getPersona,
  getSolutionArchitect,
  getSolutionApprovalButton,
  getComplexity
};
